import { render, staticRenderFns } from "./ArtworkList.vue?vue&type=template&id=84b04e3c&scoped=true&"
import script from "./ArtworkList.vue?vue&type=script&lang=js&"
export * from "./ArtworkList.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkList.vue?vue&type=style&index=0&id=84b04e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b04e3c",
  null
  
)

export default component.exports